// Adapted from:
// https://github.com/brentvatne/signature-example/blob/master/components/SignatureView.js
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, createRef } from "react";
import { PanResponder, StyleSheet, View } from "react-native";
import Svg, { G, Path } from "react-native-svg";
import { captureRef } from "../lib/captureRef";
/**
 * A blank UI element that tracks user touch events to capture a signature
 * which can be converted into an image URI via `takeSnapshotAsync`
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-126}
 */ export var SignatureView = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SignatureView, Component);
    function SignatureView() {
        _class_call_check(this, SignatureView);
        var _this;
        _this = _call_super(this, SignatureView, arguments), _define_property(_this, "_panResponder", PanResponder.create({
            onStartShouldSetPanResponder: function(evt, gs) {
                return true;
            },
            onMoveShouldSetPanResponder: function(evt, gs) {
                return true;
            },
            onPanResponderGrant: function(evt) {
                return _this.onTouch(evt);
            },
            onPanResponderMove: function(evt) {
                return _this.onTouch(evt);
            },
            onPanResponderRelease: function() {
                return _this.onResponderRelease();
            }
        })), _define_property(_this, "state", {
            currentMax: 0,
            currentPoints: [],
            donePaths: [],
            newPaths: [],
            reaction: new Reaction()
        }), _define_property(_this, "viewRef", /*#__PURE__*/ createRef());
        return _this;
    }
    _create_class(SignatureView, [
        {
            key: "clear",
            value: function clear() {
                this.setState({
                    currentMax: 0,
                    currentPoints: [],
                    donePaths: [],
                    newPaths: [],
                    reaction: new Reaction()
                });
            }
        },
        {
            key: "takeSnapshotAsync",
            value: function takeSnapshotAsync(options) {
                var _this = this;
                return _async_to_generator(function() {
                    var result;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.viewRef.current) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    captureRef(_this.viewRef.current, {
                                        format: options.format === 'jpeg' ? 'jpg' : 'png',
                                        quality: options.quality
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    {
                                        uri: result
                                    }
                                ];
                            case 2:
                                return [
                                    2,
                                    {
                                        uri: ''
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onTouch",
            value: function onTouch(evt) {
                var _ref = [
                    evt.nativeEvent.locationX,
                    evt.nativeEvent.locationY
                ], x = _ref[0], y = _ref[1];
                var newCurrentPoints = _to_consumable_array(this.state.currentPoints);
                newCurrentPoints.push({
                    x: x,
                    y: y
                });
                this.setState({
                    donePaths: this.state.donePaths,
                    currentPoints: newCurrentPoints,
                    currentMax: this.state.currentMax
                });
            }
        },
        {
            key: "onResponderRelease",
            value: function onResponderRelease() {
                var newPaths = this.state.donePaths;
                if (this.state.currentPoints.length > 0) {
                    // Cache the shape object so that we aren't testing
                    // whether or not it changed; too many components?
                    newPaths.push({
                        key: this.state.currentMax.toString(),
                        d: this.state.reaction.pointsToSvg(this.state.currentPoints)
                    });
                }
                this.state.reaction.addGesture(this.state.currentPoints);
                this.setState({
                    donePaths: newPaths,
                    currentPoints: [],
                    currentMax: this.state.currentMax + 1
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _jsx(View, {
                    style: [
                        styles.drawContainer,
                        this.props.style
                    ],
                    children: /*#__PURE__*/ _jsxs(View, _object_spread_props(_object_spread({}, this._panResponder.panHandlers), {
                        style: {
                            height: '100%',
                            width: '100%'
                        },
                        ref: this.viewRef,
                        collapsable: false,
                        children: [
                            /*#__PURE__*/ _jsx(Svg, {
                                style: styles.drawSurface,
                                width: "100%",
                                height: "100%",
                                children: /*#__PURE__*/ _jsxs(G, {
                                    children: [
                                        this.state.donePaths.map(function(donePath) {
                                            return /*#__PURE__*/ _jsx(Path, {
                                                d: donePath.d,
                                                stroke: "#000000",
                                                strokeWidth: 3,
                                                fill: "none"
                                            }, donePath.key);
                                        }),
                                        /*#__PURE__*/ _jsx(Path, {
                                            d: this.state.reaction.pointsToSvg(this.state.currentPoints),
                                            stroke: "#000000",
                                            strokeWidth: 3,
                                            fill: "none"
                                        }, this.state.currentMax)
                                    ]
                                })
                            }),
                            this.props.children
                        ]
                    }))
                });
            }
        }
    ]);
    return SignatureView;
}(Component);
var Reaction = /*#__PURE__*/ function() {
    "use strict";
    function Reaction() {
        var gestures = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        _class_call_check(this, Reaction);
        _define_property(this, "gestures", void 0);
        _define_property(this, "replayedGestures", void 0);
        _define_property(this, "_offsetX", 0);
        _define_property(this, "_offsetY", 0);
        this.gestures = gestures || [];
        this.replayedGestures = [
            []
        ];
    }
    _create_class(Reaction, [
        {
            key: "addGesture",
            value: function addGesture(points) {
                if (points.length > 0) {
                    this.gestures.push(points);
                }
            }
        },
        {
            key: "setOffset",
            value: function setOffset(options) {
                this._offsetX = options.x;
                this._offsetY = options.y;
            }
        },
        {
            key: "pointsToSvg",
            value: function pointsToSvg(points) {
                var offsetX = this._offsetX;
                var offsetY = this._offsetY;
                if (points.length > 0) {
                    var path = "M ".concat(points[0].x - offsetX, ",").concat(points[0].y - offsetY);
                    points.forEach(function(point) {
                        path = path + " L ".concat(point.x - offsetX, ",").concat(point.y - offsetY);
                    });
                    return path;
                } else {
                    return '';
                }
            }
        },
        {
            key: "replayLength",
            value: function replayLength() {
                return this.replayedGestures.length;
            }
        },
        {
            key: "empty",
            value: function empty() {
                return this.gestures.length === 0;
            }
        },
        {
            key: "copy",
            value: function copy() {
                return new Reaction(this.gestures.slice());
            }
        },
        {
            key: "done",
            value: function done() {
                return this.empty() || this.replayedGestures.length === this.gestures.length && this.lastReplayedGesture().length === this.gestures[this.gestures.length - 1].length;
            }
        },
        {
            key: "lastReplayedGesture",
            value: function lastReplayedGesture() {
                return this.replayedGestures[this.replayedGestures.length - 1];
            }
        },
        {
            key: "stepGestureLength",
            value: function stepGestureLength() {
                var gestureIndex = this.replayedGestures.length - 1;
                if (!this.gestures[gestureIndex]) {
                    return;
                }
                if (this.replayedGestures[gestureIndex].length >= this.gestures[gestureIndex].length) {
                    this.replayedGestures.push([]);
                }
            }
        },
        {
            key: "step",
            value: function step() {
                if (this.done()) {
                    return true;
                }
                this.stepGestureLength();
                var gestureIndex = this.replayedGestures.length - 1;
                var pointIndex = this.replayedGestures[gestureIndex].length;
                var point = this.gestures[gestureIndex][pointIndex];
                this.replayedGestures[gestureIndex].push(point);
                return false;
            }
        }
    ]);
    return Reaction;
}();
var styles = StyleSheet.create({
    drawContainer: {
        flex: 1
    },
    drawSurface: {
        backgroundColor: 'transparent'
    }
});
